exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___2MUHV{display:grid;gap:1em}@media screen and (min-width:850px){.index-module__wrapper___2MUHV{grid-template-columns:1fr auto auto}}.index-module__wrapper___2MUHV label{margin-bottom:0}.index-module__wrapper___2MUHV label button{width:100%;height:100%}.index-module__wrapper___2MUHV .index-module__file-input___1XR9y{display:none}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___2MUHV",
	"file-input": "index-module__file-input___1XR9y"
};